/*
 *   File : custom-select.js
 *   Author : https://evoqins.com
 *   Description : Custom select component
 *   Integrations : react-select
 *   Version : 1.0.0
 */

import React, { memo } from "react";
import Select, { components } from "react-select";

// Custom Option component with checkbox (only for type === 3)
const CheckboxOption = (props) => {
  return (
    <components.Option {...props}>
      <input
        type="checkbox"
        checked={props.isSelected}
        onChange={() => null}
        style={{ marginRight: 8 }}
      />
      {props.label}
    </components.Option>
  );
};

const CustomSelectBox = (props) => {
  // handle select value
  const valueChange = (e) => {
    props.selectChange(e);
  };

  return (
    <div className="z-2">
      {props.label && (
        <label
          className={
            props.labelClass
              ? props.labelClass
              : "e-text-black e-primary-font-poppins e-font-14 pb-2 e-font-weight-500 line-height-20px"
          }
        >
          {props.label}
          {!props.optional && <span className="text-danger">*</span>}
        </label>
      )}
      <div className="z-3">
        <Select
          isSearchable={props.isSearchable}
          isClearable={props.isClearable}
          className={`${props.className}`}
          isDisabled={props.isDisabled}
          options={props.options}
          value={props.value ? props.value : ""}
          isMulti={props.selectType || props.type === 3}
          placeholder={props.placeholder}
          defaultValue={props.defaultValue}
          menuIsOpen={props.menuIsOpen}
          menuPortalTarget={props.menuPortalTarget}
          onMenuOpen={props.onMenuOpen}
          onMenuClose={props.onMenuClose}
          onChange={(e) => valueChange(e)}
          components={props.type === 3 ? { Option: CheckboxOption } : undefined}
          styles={{
            placeholder: (styles) => ({
              ...styles,
              color: props.type === 2 ? "#1D1D1B" : "#9c9c9c",
              fontFamily: "Poppins",
              fontSize: "14px",
              fontWeight: "400",
            }),
            dropdownIndicator: (base, state) => ({
              ...base,
              transition: "all .2s ease",
              transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null,
            }),
            control: (styles, state) => ({
              ...styles,
              // zIndex: 999,
              fontSize: props.type === 2 ? "" : "14px",
              fontWeight: props.type === 3 ? "500" : "",
              borderColor:
                props.type === 4
                  ? props.error
                    ? "#e03535"
                    : "#D3D3D3"
                  : props.borderColor
                  ? props.borderColor
                  : state.menuIsOpen
                  ? props.type === 1
                    ? "#7940E7"
                    : "transparent"
                  : props.type === 1
                  ? "#E3E5E5"
                  : "transparent",

              boxShadow:
                props.type === 2 || props.type === 3 || props.type === 4
                  ? ""
                  : "0px 0px 12px 0px #0000000D",
              "&:hover": {
                borderColor:
                  props.type === 4
                    ? "#7940E7"
                    : props.type === 1
                    ? "#7940E7"
                    : "transparent",
              },
              padding:
                props.type === 2 ? "" : props.type === 4 ? ".5rem 0" : "",
              borderRadius:
                props.type === 1 ? "25px" : props.type === 2 ? "8px" : "0.5rem",
              width: props.type === 4 ? "100%" : props.width || "",
              height: props.type === 4 ? "100%" : styles.height,
              cursor: "pointer",
              background: props.type === 4 ? "white" : "transparent",
            }),
            menuList: (styles) => ({
              ...styles,
              zIndex: 9,
              fontSize: props.type === 2 || 3 ? "14px" : "12px",
              maxHeight: "180px",
              width: props.type === 2 ? "100%" : "auto",
              "&::-webkit-scrollbar-thumb": {
                background: "#7940E7",
                borderRadius: "3rem",
              },
              "&::-webkit-scrollbar": {
                width: "0.125rem",
                display: "block",
              },
            }),
            option: (styles, { isSelected, isFocused }) => ({
              ...styles,
              backgroundColor: isSelected
                ? "#9B81F5"
                : isFocused
                ? "#EEE8FC"
                : "white",
              color: isSelected ? "white" : "black",
              cursor: "pointer",
            }),
            menuPortal: (base) => ({
              ...base,
              zIndex: 9,
              position: "absolute",
            }),
            multiValue: (styles) => ({
              ...styles,
              backgroundColor:
                props.type === 3 ? "#fff" : styles.backgroundColor,
              border: props.type === 3 ? "1px solid #D6D6D6" : "none",
              borderRadius: "4px",
              margin: "2px",
            }),
            multiValueLabel: (styles) => ({
              ...styles,
              color: "#000",
              fontWeight: props.type === 3 ? "500" : "normal",
            }),
          }}
          {...props}
        />

        {props.error && (
          <p className="mb-0 e-text-cg-red e-primary-font-poppins e-font-12 line-height-12px pt-1">
            {props.error}
          </p>
        )}
      </div>
    </div>
  );
};

export default memo(CustomSelectBox);
